<template>
  <b-card
    :title="title"
    :loading="loading"
    :error-message="errorMessage"
    @cancel="$emit('cancel')"
    @submit="submitForm"
    :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
    :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
  >
    <!-- <b-select
            v-model="product.product_category_id"
            :items="categories"
            :item-text="`name[${lang}]`"
            item-value="product_category_id"
            label="Select Category"
            no-top-margin
            :success="success.category"
            :error-messages="error.category"
            @focus="error.category = ''"
            @blur="validateCategory"
        ></b-select> -->

    <b-select
      v-model="product.product_tag_id"
      :items="productsTags"
      item-text="name"
      item-value="product_tag_id"
      :label="translations.selectProductTag[lang]"
      :success="success.tag"
      :error-messages="error.tag"
      @focus="error.tag = ''"
      @blur="validateTag"
    ></b-select>

    <b-text-field
      v-if="!bulk"
      v-model="product.name[productLang]"
      :label="translations.productNameModal[lang]"
      :success="productLang === 'el' ? success.name : false"
      :error-messages="error.name"
      @focus="error.name = ''"
      @blur="validateName"
    >
      <template v-slot:append>
        <b-lang-menu v-model="productLang" type="inner"></b-lang-menu>
      </template>
    </b-text-field>

    <b-textarea
      v-if="!bulk"
      v-model="product.description[descriptionLang]"
      :label="translations.productDescriptionModal[lang]"
      :success="descriptionLang === 'el' ? success.description : false"
      :error-messages="error.description"
      @focus="error.description = ''"
      @blur="validateDescription"
    >
      <template v-slot:append>
        <b-lang-menu v-model="descriptionLang" type="inner"></b-lang-menu>
      </template>
    </b-textarea>
    <b-text-field
      v-if="!bulk"
      v-model="product.sku_number"
      label="SKU"
      :success="success.productIdentifier"
      :error-messages="error.productIdentifier"
      @focus="error.productIdentifier = ''"
    >
    </b-text-field>

    <v-row no-gutters>
      <v-col cols="12">
        <h4 class="secondary--text mt-3">
          {{ translations.prices[lang] }}
        </h4>
      </v-col>
      <v-col cols="6" class="pr-2">
        <b-text-field
          v-model="product.retail_price"
          type="number"
          :label="translations.sellingPriceModal[lang]"
          prepend-inner-icon="mdiCurrencyEur"
          :success="success.sellingPrice"
          :error-messages="error.sellingPrice"
          @focus="error.sellingPrice = ''"
          @blur="validateSellingPrice"
        ></b-text-field>
      </v-col>
      <v-col cols="6" class="pl-2">
        <b-text-field
          v-model="product.wholesale_price"
          type="number"
          :label="translations.wholesalePriceModal[lang]"
          prepend-inner-icon="mdiCurrencyEur"
          :success="success.wholesalePrice"
          :error-messages="error.wholesalePrice"
          @focus="error.wholesalePrice = ''"
          @blur="validateWholesalePrice"
        ></b-text-field>
      </v-col>
      <v-col v-if="!bulk" cols="6" class="pr-2 pl-0">
        <b-text-field
          v-model="product.maximum_price_per_transaction"
          type="number"
          :label="translations.maxPricePerTransaction[lang]"
          prepend-inner-icon="mdiCurrencyEur"
          :success="success.maxPrice"
          :error-messages="error.maxPrice"
          @focus="error.maxPrice = ''"
          @blur="validateMaxPrice"
        ></b-text-field>
      </v-col>
      <v-col v-if="!bulk" cols="6" class="pr-2 pl-0"> </v-col>
      <!-- <v-col cols="12">
                <b-text-field
                    v-model="product.product_identifier"
                    label="Product Id"
                ></b-text-field>
            </v-col> -->

      <v-col cols="6" class="pr-2">
        <b-text-field
          v-model="product.reward_points"
          type="number"
          :label="translations[storeMode][lang]"
          :success="success.rewardPoints"
          :error-messages="error.rewardPoints"
          @focus="error.rewardPoints = ''"
          @blur="validateRewardPoints"
        ></b-text-field>
      </v-col>
      <v-col v-if="!bulk" cols="6" class="pl-2">
        <b-select
          v-model="product.reward_type_id"
          :label="translations.rewardType[lang]"
          :items="rewardTypes"
          :success="success.rewardType"
          :error-messages="error.rewardType"
          @focus="error.rewardType = ''"
          @blur="validateRewardType"
        ></b-select>
      </v-col>

      <v-col v-if="!bulk">
        <v-autocomplete
          :items="loyaltiesData"
          v-model="product.loyalty_program_ids"
          :item-text="`name[${lang}]`"
          item-value="loyalty_program_id"
          menu-props="offsetY"
          :label="translations.loyalties[lang]"
          class="mt-4"
          outlined
          dense
          hide-details
          clearable
          multiple
          :search-input.sync="searchLoyalties"
          :loading="loading"
          :disable-lookup="true"
          item-disabled="disable"
        >
          <template v-slot:selection="data">
            <v-chip
              v-if="product.loyalty_program_ids.length < 5"
              v-bind="data.attrs"
              close
              small
              class="mt-1"
              @click:close="removeSelectedLoyalty(data)"
            >
              {{ data.item.name[lang] }}
            </v-chip>
            <div v-else-if="data.index === 0">
              {{ `${product.loyalty_program_ids.length} ` + translations.loyaltiesSelected[lang] }}
            </div>
          </template>
          <template v-slot:append-item>
            <div v-intersect="endIntersectLoyalties"></div>
            <v-list-item v-if="loading">
              <v-list-item-action class="ml-1">
                <v-row class="d-flex align-center">
                  <v-btn
                    class="text-capitalize"
                    depressed
                    fab
                    small
                    :loading="true"
                    style="background: transparent"
                  >
                  </v-btn>
                  <span class="pa-2">{{ translations.loadMore[lang] }}</span>
                </v-row>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col md="12">
        <v-checkbox
          v-model="product.update_store_products.status"
          color="secondary"
          class="mt-3 pt-0"
          hide-details="auto"
          v-if="!bulk && mode === 'update'"
        >
          <template v-slot:label>
            <h4 class="secondary--text">
              {{ translations.updateProductToExistingStores[lang] }}
            </h4>
          </template>
        </v-checkbox>
      </v-col>
      <v-col v-if="!bulk && (mode != 'update' || product.update_store_products.status)" md="12">
        <v-autocomplete
          ref="storesAutocomplete"
          prepend-inner-icon="mdi-store"
          :items="storesData"
          v-model="selectedStores"
          item-text="label"
          item-value="store_id"
          :menu-props="storesMenuProps"
          :label="translations.stores[lang]"
          class="mt-4"
          outlined
          clearable
          dense
          hide-details
          multiple
          :search-input.sync="searchStores"
          :loading="loading"
          :disable-lookup="true"
          item-disabled="disable"
          @focus="storesMenuOpen = true"
          @blur="onStoresAutocompleteBlur"
        >
          <template v-slot:selection="data">
            <v-chip
              v-if="!allStoresAreSelected && selectedStores.length < 5"
              v-bind="data.attrs"
              small
              close
              class="mt-1"
              @click:close="removeSelectedStore(data)"
            >
              {{ data.item.label }}
            </v-chip>
            <v-chip v-else-if="data.index === 0" v-bind="data.attrs" small class="mt-1">
              <span v-if="allStoresAreSelected">
                {{ translations.all[lang] }}
              </span>
              <span v-else-if="selectedStores.length">
                {{ `${selectedStores.length} ${translations.storesSelected[lang]}` }}
              </span>
            </v-chip>
          </template>
          <template v-slot:prepend-item>
            <v-list-item
              v-if="!searchStores"
              ripple
              style="cursor: pointer"
              @click="toggleSelectAllStores"
            >
              <v-checkbox
                @click.stop.prevent="toggleSelectAllStores"
                v-model="allStoresAreSelected"
                readonly
                class="ml-0 mt-0 mb-n3 transition-all"
                color="secondary"
              >
              </v-checkbox>
              <v-list-item-action class="ml-6">
                {{ translations.all[lang] }}
              </v-list-item-action>
            </v-list-item>
          </template>

          <template v-slot:append-item>
            <div v-intersect="endIntersectStores"></div>
            <v-list-item v-if="loading">
              <v-list-item-action class="ml-1">
                <v-row class="d-flex align-center">
                  <v-btn
                    class="text-capitalize"
                    depressed
                    fab
                    small
                    :loading="true"
                    style="background: transparent"
                  >
                  </v-btn>
                  <span class="pa-2">{{ translations.loadMore[lang] }}</span>
                </v-row>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col md="12">
        <v-checkbox
          v-model="product.update_store_products.prices_included"
          color="secondary"
          class="mt-3 pt-0"
          hide-details="auto"
          v-if="product.update_store_products.status"
        >
          <template v-slot:label>
            <h4 class="secondary--text">{{ translations.updatePricesQ[lang] }}</h4>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>

    <v-checkbox
      v-if="!bulk"
      v-model="product.reward_points_shared"
      color="secondary"
      class="mt-3 pt-0"
      hide-details="auto"
    >
      <template v-slot:label>
        <h4 class="secondary--text">
          {{ translations.subsidizedPoints[lang] }}
        </h4>
      </template>
    </v-checkbox>

    <v-row v-if="!bulk" no-gutters>
      <v-col cols="4" class="pr-2 ml-4">
        <v-checkbox
          v-model="product.reward_points_shared_options.online"
          color="secondary"
          class="mt-3 pt-0"
          hide-details="auto"
          v-if="product.reward_points_shared"
        >
          <template v-slot:label>
            <h4 class="secondary--text">Online</h4>
          </template>
        </v-checkbox>
      </v-col>

      <v-col cols="4" class="pr-2">
        <v-checkbox
          v-model="product.reward_points_shared_options.offline"
          color="secondary"
          class="mt-3 pt-0"
          hide-details="auto"
          v-if="product.reward_points_shared"
        >
          <template v-slot:label>
            <h4 class="secondary--text">Offline</h4>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>

    <hr v-if="product.reward_points_shared" class="mt-4" />

    <v-checkbox
      v-if="!bulk"
      v-model="product.has_image"
      color="secondary"
      class="mt-3 pt-0"
      hide-details="auto"
    >
      <template v-slot:label>
        <h4 class="secondary--text">
          {{ translations.imageDisplayText[lang] }}
        </h4>
      </template>
    </v-checkbox>

    <v-card v-if="product.has_image" outlined class="mt-3">
      <v-card-title class="subtitle-1 font-weight-medium">
        {{ translations.productImageOptional[lang] }}
      </v-card-title>
      <v-row no-gutters justify="space-between" class="pa-5">
        <v-col cols="6">
          <v-img :src="product.image"></v-img>
        </v-col>
        <v-col cols="5" class="mr-3">
          <v-file-input
            color="secondary"
            outlined
            dense
            hide-details="auto"
            @change="onFileSelected"
            :error-messages="error.image"
            :success="success.image"
          ></v-file-input>
        </v-col>
      </v-row>
    </v-card>

    <v-checkbox
      v-if="!bulk"
      v-model="showWeekdays"
      color="secondary"
      class="mt-3 pt-0"
      hide-details="auto"
      id="showWeekdays"
    >
      <template v-slot:label>
        <h4 class="secondary--text">
          {{ translations.specificDaysText[lang] }}
        </h4>
      </template>
    </v-checkbox>

    <v-card v-if="showWeekdays" outlined class="mt-3">
      <v-card-title class="subtitle-1 font-weight-medium" style="word-break: normal">
        {{ translations.chooseDaysText[lang] }}
      </v-card-title>
      <v-container>
        <v-row no-gutters>
          <v-col v-for="(weekday, i) in weekdays" :key="i" cols="3" class="pr-2">
            <v-checkbox
              v-model="product.availability_days"
              color="secondary"
              class="mt-0"
              :value="i"
              hide-details
            >
              <template v-slot:label>
                <h4 class="secondary--text" v-text="weekday[lang]"></h4>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-checkbox
      v-if="!bulk"
      v-model="product.published"
      color="secondary"
      class="mt-3 pt-0"
      hide-details="auto"
    >
      <template v-slot:label>
        <h4 class="secondary--text">
          {{ translations.publish[lang] }}
        </h4>
      </template>
    </v-checkbox>

    <v-checkbox
      v-model="product.group_product"
      color="secondary"
      class="mt-3 pt-0"
      hide-details="auto"
      v-if="!bulk && mode === 'create'"
    >
      <template v-slot:label>
        <h4 class="secondary--text">Group Product</h4>
      </template>
    </v-checkbox>

    <v-checkbox
      v-if="!bulk"
      v-model="product.has_valid_period"
      color="secondary"
      class="mt-3 pt-0"
      hide-details="auto"
    >
      <template v-slot:label>
        <h4 class="secondary--text">
          {{ translations.timePeriodCheckLabel[lang] }}
        </h4>
      </template>
    </v-checkbox>
    <v-card v-if="product.has_valid_period" outlined class="mt-3">
      <v-card-title class="subtitle-1 font-weight-medium" style="word-break: normal">
        {{ translations.timePeriodCheckDescription[lang] }}
      </v-card-title>
      <v-container>
        <v-row no-gutters>
          <v-col cols="6" class="pr-2">
            <v-menu :close-on-content-click="true" offset-y max-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :label="translations.fromDate[lang]"
                  color="secondary"
                  autocomplete="off"
                  hint="YYYY/DD format"
                  outlined
                  dense
                  clearable
                  hide-details
                  v-on="on"
                  v-model="product.valid_from"
                ></v-text-field>
              </template>

              <v-date-picker
                color="secondary"
                no-title
                :min="new Date().toISOString().substr(0, 10)"
                v-model="product.valid_from"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6" class="pr-2">
            <v-menu :close-on-content-click="true" offset-y max-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :label="translations.toDate[lang]"
                  color="secondary"
                  autocomplete="off"
                  hint="YYYY/DD format"
                  outlined
                  dense
                  clearable
                  hide-details
                  v-on="on"
                  v-model="product.valid_to"
                ></v-text-field>
              </template>

              <v-date-picker
                color="secondary"
                no-title
                :min="new Date().toISOString().substr(0, 10)"
                v-model="product.valid_to"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </b-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import validators from '@/utils/validators/loyaltyPanel/product';
import translations from '@/utils/translations/loyaltyPanel/products/productsTab';
import debounce from 'lodash/debounce';
import { cloneDeep } from 'lodash';

export default {
  name: 'ProductForm',

  props: {
    mode: String,
    bulk: String,
    selectedProducts: Array,
  },

  mixins: [validators, translations],

  data() {
    return {
      productLang: this.$route.params.lang,
      changeNameElAuto: true,
      changeNameItAuto: true,
      changeNameEnAuto: true,
      descriptionLang: this.$route.params.lang,
      changeDescriptionElAuto: true,
      changeDescriptionItAuto: true,
      changeDescriptionEnAuto: true,
      // hasValidPeriod: false,
      imageFile: null,
      weekdays: [
        { el: 'Κυριακή', en: 'Sunday', it: 'Domenica' },
        { el: 'Δευτέρα', en: 'Monday', it: 'Lunedì' },
        { el: 'Τρίτη', en: 'Tuesday', it: 'Martedì' },
        { el: 'Τετάρτη', en: 'Wednesday', it: 'Mercoledì' },
        { el: 'Πέμπτη', en: 'Thursday', it: 'Giovedì' },
        { el: 'Παρασκευή', en: 'Friday', it: 'Venerdì' },
        { el: 'Σάββατο', en: 'Saturday', it: 'Sabato' },
      ],
      searchLoyalties: '',
      selectedLoyaltiesData: [],
      loyaltyPage: 1,
      selectedStores: [],
      selectedStoresData: [],
      pageStores: 1,
      searchStores: '',
      allStoresAreSelected: false,
      storesMenuOpen: false,
      suppressNextOutsideStoresClick: false,
    };
  },

  computed: {
    ...mapState(['loading', 'errorMessage', 'resetSuccess', 'resetValidation', 'store']),
    ...mapState('loyaltyPanel/products', [
      'categories',
      'productsTags',
      'product',
      'hasValidPeriod',
      'validationErrors',
    ]),
    ...mapState('loyaltyPanel', ['companyStoresPagination', 'companyStores']),

    rewardTypes() {
      return [
        {
          text: this.translations.perTransaction[this.lang],
          value: 1,
        },
        {
          text: this.translations.perEuro[this.lang],
          value: 2,
        },
        {
          text: this.translations.perItem[this.lang],
          value: 3,
        },
        {
          text: this.translations.perLitre[this.lang],
          value: 4,
        },
      ];
    },

    lang() {
      return this.$route.params.lang;
    },

    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    title() {
      return this.mode === 'create'
        ? this.translations.createTitle[this.lang]
        : this.translations.updateTitle[this.lang];
    },

    showWeekdays: {
      get() {
        return this.$store.state.loyaltyPanel.products.showWeekdays;
      },

      set(val) {
        this.setShowWeekdays(val);
      },
    },
    activeStores() {
      return this.companyStores.filter((store) => store.active);
    },
    query() {
      let query = '?';

      for (let key in this.$route.query) {
        query += `${key}=${this.$route.query[key]}&`;
      }

      return query.slice(0, query.length - 1);
    },
    loyalties() {
      return this.$store.state.loyaltyPanel.loyalties;
    },

    loyaltiesPagination() {
      return this.$store.state.loyaltyPanel.loyaltiesPagination;
    },
    loyaltiesData() {
      return [...this.loyalties, ...this.selectedLoyaltiesData];
    },
    loyaltyQuery() {
      if (this.searchLoyalties) {
        return `?q=${this.searchLoyalties}&page=${this.loyaltyPage}`;
      }

      return `?page=${this.loyaltyPage}`;
    },
    selectedProductIds() {
      return this.selectedProducts.map((product) => product.product_id);
    },
    storesData() {
      return [...this.companyStores, ...this.selectedStoresData].map((e) => ({
        ...e,
        disable: this.allStoresAreSelected,
        label: `${e.store_code || ''} ${e.name}`,
      }));
    },

    queryStores() {
      let query = `?page=${this.pageStores}`;
      if (this.searchStores) {
        query += `&q=${this.searchStores}`;
      }
      return query;
    },
    storesMenuProps() {
      return {
        offsetY: true,
        closeOnClick: true,
        closeOnContentClick: false,
      };
    },
  },

  methods: {
    ...mapMutations(['setResetSuccess', 'setResetValidation', 'setLoading']),
    ...mapMutations('loyaltyPanel/products', ['setShowWeekdays', 'setItem', 'setValidationErrors']),

    ...mapActions('loyaltyPanel', ['getLoyalties', 'loadStores']),
    ...mapActions('loyaltyPanel/products', [
      'getCategories',
      'getProductsTags',
      'create',
      'update',
      'updateBulk',
    ]),

    submitForm() {
      if (!this.bulk) {
        this.product.maximum_price_per_transaction =
          this.product.maximum_price_per_transaction || 0;
        if ((this.validateImage && !this.validateImage(this.imageFile)) || this.error.image) {
          return;
        }

        this[this.mode](this.imageFile);
      } else {
        this.updateBulk(this.selectedProductIds);
      }
    },
    removeSelectedLoyalty(data) {
      this.product.loyalty_program_ids.splice(data.index, 1);
    },
    onFileSelected(event) {
      if (!event) return;
      this.imageFile = Array.isArray(event) ? event[0] : event;

      const validImg = this.validateImage ? this.validateImage(this.imageFile) : true;
      if (!validImg) return;

      const reader = new FileReader();
      reader.readAsDataURL(this.imageFile);
      reader.onload = (e) => (this.product.image = e.target.result);
    },
    endIntersectLoyalties(entries, observer, isIntersecting) {
      if (isIntersecting && this.loyalties?.length < this.loyaltiesPagination.total) {
        this.loadMoreLoyalties();
      }
    },

    async loadMoreLoyalties() {
      this.loyaltyPage++;
      const body = {
        query: this.loyaltyQuery,
        page: this.loyaltyPage,
      };
      this.setLoading(true);
      await this.getLoyalties(body);
      this.setLoading(false);
    },
    handleSearchLoyalties() {
      const body = {
        query: this.loyaltyQuery,
        page: this.loyaltyPage,
      };

      this.getLoyalties(body);
    },
    handleSearchStores() {
      const body = {
        query: this.queryStores,
        page: this.pageStores,
      };
      this.loadStores(body);
    },

    async loadMoreStores() {
      this.pageStores++;
      const body = {
        query: this.queryStores,
        page: this.pageStores,
      };
      this.setLoading(true);
      await this.loadStores(body);
      this.setLoading(false);
    },
    endIntersectStores(entries, observer, isIntersecting) {
      if (
        isIntersecting &&
        this.companyStores &&
        this.companyStores.length < this.companyStoresPagination.total
      ) {
        this.loadMoreStores();
      }
    },
    isStoresAutocompleteEventTarget(target) {
      const storesAutocompleteEl = this.$refs.storesAutocomplete?.$el;
      const menuContent = this.$refs.storesAutocomplete?.$refs?.menu?.$refs?.content;

      if (storesAutocompleteEl && storesAutocompleteEl.contains(target)) {
        return true;
      }

      if (menuContent && menuContent.contains(target)) {
        return true;
      }

      return false;
    },
    handleStoresOutsidePointerDown(event) {
      if (!this.storesMenuOpen) {
        return;
      }

      if (this.isStoresAutocompleteEventTarget(event.target)) {
        return;
      }

      this.suppressNextOutsideStoresClick = true;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      this.closeStoresAutocompleteMenu();
    },
    handleStoresOutsideClick(event) {
      if (this.suppressNextOutsideStoresClick) {
        this.suppressNextOutsideStoresClick = false;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        return;
      }

      if (!this.storesMenuOpen) {
        return;
      }

      if (this.isStoresAutocompleteEventTarget(event.target)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      this.closeStoresAutocompleteMenu();
    },
    onStoresAutocompleteBlur() {
      this.searchStores = '';
      this.storesMenuOpen = false;
    },
    closeStoresAutocompleteMenu() {
      this.storesMenuOpen = false;
      const storesAutocomplete = this.$refs.storesAutocomplete;
      if (storesAutocomplete && typeof storesAutocomplete.blur === 'function') {
        storesAutocomplete.blur();
      }
    },
    toggleSelectAllStores(val) {
      if (!val || this.allStoresAreSelected) {
        this.allStoresAreSelected = false;
        this.$set(this, 'allStoresAreSelected', false);
        this.selectedStores.map((item, index) => {
          this.selectedStores.splice(index, this.selectedStores.length);
        });
      } else {
        this.allStoresAreSelected = true;
        this.$set(this, 'allStoresAreSelected', true);
        this.companyStores.map((item) => {
          if (!this.selectedStores.includes(item.store_id)) {
            this.selectedStores.push(item.store_id);
          }
        });

        this.$nextTick(() => this.closeStoresAutocompleteMenu());
      }
    },
    removeSelectedStore(data) {
      this.selectedStores.splice(data.index, 1);
    },
  },

  watch: {
    product: {
      handler(val) {
        if (!val.update_store_products.status) {
          val.update_store_products.prices_included = false;
        }
        if (!val.has_valid_period) {
          val.valid_from = null;
          val.valid_to = null;
        }
        if (!!val.valid_from || !!val.valid_to) {
          val.has_valid_period = true;
        }
      },
      deep: true,
    },

    ['$route.params.lang'](val) {
      this.productLang = val;
      this.descriptionLang = val;
    },

    ['product.name.en'](val) {
      if (this.lang == 'en') {
        if (this.changeNameElAuto) {
          this.product.name.el = val;
        }

        if (this.changeNameItAuto) {
          this.product.name.it = val;
        }

        this.changeNameEnAuto = false;
      } else if (val != this.product.name[this.lang]) {
        this.changeNameEnAuto = false;
      }
    },

    ['product.name.el'](val) {
      if (this.lang == 'el') {
        if (this.changeNameEnAuto) {
          this.product.name.en = val;
        }

        if (this.changeNameItAuto) {
          this.product.name.it = val;
        }

        this.changeNameElAuto = false;
      } else if (val != this.product.name[this.lang]) {
        this.changeNameElAuto = false;
      }
    },

    ['product.name.it'](val) {
      if (this.lang == 'it') {
        if (this.changeNameElAuto) {
          this.product.name.el = val;
        }

        if (this.changeNameEnAuto) {
          this.product.name.en = val;
        }

        this.changeNameItAuto = false;
      } else if (val != this.product.name[this.lang]) {
        this.changeNameItAuto = false;
      }
    },

    ['product.description.en'](val) {
      if (this.lang == 'en') {
        if (this.changeDescriptionElAuto) {
          this.product.description.el = val;
        }

        if (this.changeDescriptionItAuto) {
          this.product.description.it = val;
        }

        this.changeDescriptionEnAuto = false;
      } else if (val != this.product.description[this.lang]) {
        this.changeDescriptionEnAuto = false;
      }
    },

    ['product.description.el'](val) {
      if (this.lang == 'el') {
        if (this.changeDescriptionEnAuto) {
          this.product.description.en = val;
        }

        if (this.changeDescriptionItAuto) {
          this.product.description.it = val;
        }

        this.changeDescriptionElAuto = false;
      } else if (val != this.product.description[this.lang]) {
        this.changeDescriptionElAuto = false;
      }
    },

    ['product.description.it'](val) {
      if (this.lang == 'it') {
        if (this.changeDescriptionElAuto) {
          this.product.description.el = val;
        }

        if (this.changeDescriptionEnAuto) {
          this.product.description.en = val;
        }

        this.changeDescriptionItAuto = false;
      } else if (val != this.product.description[this.lang]) {
        this.changeDescriptionItAuto = false;
      }
    },

    searchLoyalties() {
      this.loyaltyPage = 1;
      this.debouncedSearchLoyalties();
    },

    searchStores() {
      this.pageStores = 1;
      this.debouncedSearchStores();
    },

    allStoresAreSelected: {
      handler(val) {
        if (val) {
          this.product.store_ids = [];
        }
      },
      deep: true,
    },

    selectedStores: {
      handler(val) {
        if (!val?.length) {
          this.allStoresAreSelected = false;
        }
        if (!this.allStoresAreSelected) {
          if (
            (this.mode === 'create' || this.product?.update_store_products?.status) &&
            val?.length
          ) {
            this.product.store_ids = [...val];
          } else {
            this.product.store_ids = null;
          }
          this.selectedStoresData.forEach((storeData, i) => {
            let foundStore = val.find((x) => storeData && x == storeData.store_id);
            if (!foundStore) {
              this.selectedStoresData.splice(i, 1);
            }
          });
          val.forEach((id) => {
            let foundId = this.selectedStoresData.find((x) => x?.store_id == id);
            if (!foundId) {
              this.selectedStoresData.push(this.companyStores.find((x) => x?.store_id == id));
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },

    ['product.product_id']: {
      async handler(val) {
        this.allStoresAreSelected = false;
        this.selectedStores = [];
        if (!val) {
          return this.setItem({});
        } else if (this.product.stores && !this.companyStoresPagination.total) {
          await this.loadStores({
            query: this.queryStores,
            page: this.pageStores,
          });
        }
        let product = await cloneDeep(this.product);

        if (!product.stores) {
          this.product.store_ids = null;
        } else if (
          product.stores?.length === 0 ||
          product.stores?.length == this.companyStoresPagination.total
        ) {
          this.toggleSelectAllStores(true);
        } else if (product.stores?.length) {
          product.stores.forEach((store) => {
            if (!this.selectedStoresData.includes(store.store_id)) {
              this.selectedStoresData.push(store);
            }
            this.selectedStores.push(store.store_id);
          });
        }
      },
      immediate: true,
    },

    ['product.update_store_products']: {
      async handler(val) {
        if (val.status && this.selectedStores?.length) {
          this.product.store_ids = this.allStoresAreSelected ? [] : [...this.selectedStores];
        } else {
          this.product.store_ids = null;
        }
      },
      deep: true,
    },
    validationErrors: {
      handler(val) {
        if (val && Object.keys(val).length) {
          this.handleServerValidationErrors(val);
        }
      },
      deep: true,
    },
    companyStores: {
      handler(val) {
        if (this.allStoresAreSelected) {
          val.map((item) => {
            if (!this.selectedStores.includes(item.store_id)) {
              this.selectedStores.push(item.store_id);
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
    ['product.has_image'](val) {
      if (val === false) {
        if (this.product) {
          this.product.image = null;
        }
        this.imageFile = null;
        if (this.error && typeof this.error === 'object') {
          this.error.image = '';
        }
        if (this.success && typeof this.success === 'object') {
          this.success.image = false;
        }
      }
    },
    'product.image': {
      handler(val) {
        if (val) {
          if (!this.product.has_image) {
            this.product.has_image = true;
          }
        } else {
          if (this.product && this.product.has_image) {
            this.product.has_image = false;
          }
        }
      },
      immediate: true,
    },
  },

  created() {
    this.debouncedSearchLoyalties = debounce(this.handleSearchLoyalties, 500);
    this.debouncedSearchStores = debounce(this.handleSearchStores, 500);
  },

  beforeDestroy() {
    document.removeEventListener('mousedown', this.handleStoresOutsidePointerDown, true);
    document.removeEventListener('touchstart', this.handleStoresOutsidePointerDown, true);
    document.removeEventListener('click', this.handleStoresOutsideClick, true);
  },

  async mounted() {
    document.addEventListener('mousedown', this.handleStoresOutsidePointerDown, true);
    document.addEventListener('touchstart', this.handleStoresOutsidePointerDown, true);
    document.addEventListener('click', this.handleStoresOutsideClick, true);
    this.getProductsTags();
  },
};
</script>
